import axios from "axios";
import Config from "../../../config";

const v2_actionEditScoringDefinition = (scoringId, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/scoring/definitions/${scoringId}/editar`,
        data
    });
};

export default v2_actionEditScoringDefinition;
